import React from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { DrawerInfo } from "../../components/drawerInfo/DrawerInfo.Main";
import Container from "../../components/layouts/Container";
import { ContextCart } from "../../context/Context.Cart";
import { ContextLanguage } from "../../context/Context.Language";
import { TEXT_SELECT_YOUR_PROGRAM } from "../../utils/useConstants";
import { FunctionGetPathUrl } from "../../utils/useFunction";
import { ICON_INFO } from "../../utils/useIcons";
import {
  STYLE_ADDRESS_BG,
  STYLE_HOVER_BLUE,
  STYLE_ICON_INFO_HOME,
  STYLE_MAX_WIDTH_DESKTOP,
  STYLE_TITLE_SELECTPROGRAM,
} from "../../utils/useStyle";
import HomeRenderEachProgram from "../home/render/Home.RenderEachProgram";
import ProgramGoBack from "../task/render/Program.GoBack";
import OurserviceFirstLoad from "./functions/Ourservice.FirstLoad";
import MetaTags from "../../utils/useMetaTags";

const SelectMain = React.memo(({ programs, config }) => {
  useEffect(() => {
    document?.getElementById("root")?.scrollIntoView({
      behavior: "auto",
      block: "start",
    });
  }, []);

  const { language } = React.useContext(ContextLanguage);

  const { cart } = React.useContext(ContextCart);

  // const ProgramsThatSelected = cart?.filter((item) => item?.master === true);
  const [open, setOpen] = React.useState(false);
  // const tempPrograms = programs?.map((item) => {
  //   const isExist = ProgramsThatSelected.findIndex((item2) => {
  //     return item2?.master_id === item?._id;
  //   });

  //   return {
  //     ...item,
  //     status: isExist === -1 ? true : false,
  //   };
  // });

  const navigate = useNavigate();
  return (
    <Container
      style={`text-gray-700 bg-laundry-bglight md:bg-laundry-borderbottomline relative h-full  pt-16 md:pt-[116px] `}
    >
      {language === "TH" ? (
        <MetaTags
          title="บริการของเรา - กรุงเทพ | My Laundry"
          description="My Laundry ให้บริการซักรีดเสื้อผ้าและทำความสะอาดรองเท้าอย่างมืออาชีพ บริการของเราตอบโจทย์ทุกความต้องการของคุณ ลองดูเลย!"
        />
      ) : (
        <MetaTags
          title="Our Services - Bangkok | My Laundry"
          description="My Laundry's professional services meet all your washing, ironing and shoe cleaning requirements in a one-stop solution. Try it NOW!"
        />
      )}
      <div className={`${STYLE_MAX_WIDTH_DESKTOP}  md:px-10 xl:px-37  mx-auto`}>
        <div className={`${STYLE_ADDRESS_BG} px-4 `} id="scroll_ourservice">
          <div className=" flex  ">
            <ProgramGoBack
              // onClick={() => {
              //   console.log("click");
              //   // const lastPage = sessionStorage.getItem("redirect-back-to");
              //   // if (lastPage === "/CompleteProfile") {
              //   //   return;
              //   // } else if (
              //   //   lastPage === "/OurServices" ||
              //   //   lastPage === "/OurServices/TH"
              //   // ) {
              //   //   navigate("/");
              //   // } else {
              //   //   navigate(lastPage);
              //   // }
              //   ProgramGoBack(navigate);
              // }}
              classname="mb-2.5 md:mb-6.5 flex-none"
            />
            <div className="text-center flex-shrink mx-auto w-max absolute top-[17px] md:top-6 left-1/2 transform -translate-x-1/2 ">
              <div className="flex gap-1 items-center">
                <div className={STYLE_TITLE_SELECTPROGRAM(language)}>
                  {TEXT_SELECT_YOUR_PROGRAM[language]}
                </div>
                <ICON_INFO
                  onClick={() => {
                    setOpen(true);
                  }}
                  className={`${STYLE_ICON_INFO_HOME} ${STYLE_HOVER_BLUE}`}
                />
              </div>
            </div>
          </div>
          <DrawerInfo
            open={open}
            setOpen={setOpen}
            image={FunctionGetPathUrl(config?.program_method_image_key_desktop)}
            imageMobile={FunctionGetPathUrl(
              config?.program_method_image_key_mobile
            )}
            title={TEXT_SELECT_YOUR_PROGRAM[language]}
            description={config?.program_method_description}
            description2={config?.program_method_description_2}
          />
          <HomeRenderEachProgram data={programs} />
        </div>
      </div>
      <div
        className={`${
          language === "TH" ? "h-4 md:h-11" : "h-10 md:h-11"
        } bg-white md:bg-laundry-borderbottomline`}
      ></div>
    </Container>
  );
});

export default SelectMain;
